import { RouteConfig } from 'vue-router'

import { pinia } from '@/client/store/pinia'
import { useNavbarStore } from '@/client/store/useNavbarStore'

export const supports: RouteConfig = {
  path: '/supports',
  name: 'supports',
  component: () => import('./pages/SupportPage.vue'),
  async beforeEnter(to, from, next) {
    const navbarStore = useNavbarStore(pinia)
    navbarStore.setBreadcrumb([{ name: 'サポート履歴', link: null }])
    next()
  }
}
